export const calcBetween = (a, b, p) => a + (b - a) * p
